<template>
    <div id='payAlert' v-if="alertShow">
        <div class="box"  @click.self="off">
            <div class="pubw">
                <div class="content">
                    <h2 class="h">付款方式</h2>
                    <div class="payBlock">
                        <div class="pay" v-for="item in payList" :key="item.id">
                            <div class="img_wrap">
                                <img :src="require(`${item.img}`)" alt="支付方式">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    name:'payAlert',
    props:["alertShow","callback"],
    data(){
        return {
            // 支付列表
            payList:[
                {
                    id:'01',
                    img:"./img/zfb.png"
                },
                {
                    id:'02',
                    img:"./img/wx.png"
                },
                {
                    id:'03',
                    img:"./img/cb.png"
                },
                {
                    id:'04',
                    img:"./img/zs.gif"
                }
            ]
        }
    },
    methods: {
            // 监听用户点击灰色区域
        off(){
            this.callback()
        }
    },
}
</script>

<style lang="less">
    #payAlert{
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: #656565;
        z-index: 9999;
        .box{
            display: flex;
            height: 100%;
            justify-content: center;
            align-items: center;
            animation: show .5s;
            .content{
                width: 100%;
                height: 600px;
                border-radius: 20px;
                background-color: #fff;
                padding: 30px;
                .h{
                    font-size:30px;
                }
                .payBlock{
                    display: flex;
                    flex-wrap:wrap;
                    justify-content: space-between;
                    align-items: center;
                    margin-top: 30px;
                    .pay{
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 48%;
                        height: 200px;
                        box-shadow: 0px 2px 6px #ccc;
                        border-radius: 5px;
                        margin:10px 0;
                        .img_wrap{
                            img{
                            }
                        }
                        &:hover{
                            opacity: .8;
                            cursor: pointer;
                        }
                    }
                }
            }
        }
    }
</style>